<template>
  <div ref="commentsContainer" class="comments-container no-print"
       :class="{'is-grid': isGrid,
       'is-expanded': expanded,
       'isEng' : $isStories,
       'no-comments' : !hasComments && !isStory,
       'is-start-page': fromStartButtonTemplate,
       'comments-container-auditoriumYSC': $isYSC && isAuditoriumStory}"
       :id="`header-${post.id}`" >
    <div v-if="isStory" class="comments-header is-flex" :class="{'fixed-position': setFixed, 'hidden-header cursor-pointer':!showComments, 'stories-comment-header':isStory, 'ios': iosMobile}" v-on="!showComments ? { click: toggleRepliesOnClick } : {}">
      <div v-if="!edit" class="replies-title is-marginless has-text-centered" :class="{'story-padding': isStory, 'isEng' : $isStories}">
        <span v-if="isStory" class="is-flex" :class="{'space-between': isStory}">
          <span :class="buttonTemplate" class="thumb primary-hover" @click="like" @mouseenter="showDropdown('likes')" @mouseleave="hideDropdown('likes')" @click.stop="like">
            <span class="dropper" v-if="dropdowns.likes.show && !isTouch && post.metadata.likes > 0">
              <drop-down :users="dropdowns.likes.users" :loading="dropdowns.likes.loading" @fetch="fetchLikedBy" @close="hideDropdown('likes')" @click="toggleDropDown('likes')"></drop-down>
            </span>
            <i :class="{'fa': hasLiked, 'fal': !hasLiked}" class="fa-thumbs-up"></i>
            <template v-if="post.metadata.likes"><span class="icon-label" >{{post.metadata.likes}} </span></template>
            <span class="icon-label is-hidden-mobile" v-if="isStory">{{likesLabel}}</span>
          </span>

          <span v-if="post.metadata.comments" class="metadata-comments">
            <span v-if="expanded" @click="toggleRepliesOnClick" class="is-size-7">
              <span class="has-text-weight-bold has-text-black">{{post.metadata.comments}}</span>
              <span>{{repliesLabel}} </span>
              <span :class="upClass" class="arrow-padding" ></span>
            </span>
            <span  v-else class="is-size-7">
              <span class="has-text-weight-bold has-text-black">{{post.metadata.comments}} </span>
              <span>{{repliesLabel}}</span>
              <span class="arrow-padding" :class="upClass"></span>
            </span>
            <div v-if="expanded" class="button newest is-small is-rounded is-outlined" :disabled="loading && loadAll" @click="scrollToNewest"><span class="button-icon"><i class="fal fa-arrow-alt-from-top"></i></span> &nbsp; <span class="icon-label"><span class="is-hidden-mobile">{{ $t("projectPage.jumpTo") }} </span>{{ $t("projectPage.newest") }}</span></div>
          </span>

          <span class="right-buttons is-flex">
            <div class="button reply is-small is-rounded is-outlined" :disabled="loading && loadAll" @click="openAndReply">
              <span class="button-icon"> <i class="fal fa-reply"></i> </span>
              <span class="button-text icon-label is-hidden-mobile">{{ $t("projectPage.reply") }}</span>
            </div>
            <span  v-if="!edit && !isPrivate && isStory" class="is-hoverable share-button">
              <share-menu :project="project" :post="post" :isCreatorMenu="false"></share-menu>
            </span>
          </span>
        </span>

        <span v-else>
          <span v-if="showComments"><span class="has-text-weight-semibold">{{post.metadata.comments}}</span>&nbsp;{{repliesLabel}}</span>
          <span v-else class="has-text-grey-darker"><i class="fal fa-minus-square"></i> {{post.metadata.comments}} {{repliesLabel}} {{ $t("projectPage.hidden") }}</span>
        </span>

        <div v-if="showComments && loading && loadAll" class="loader-container"><span v-if="showComments" class="loader"></span></div>
      </div>
    </div>
    <div v-if="isStory" class="header-placeholder" :class="{ 'placeholder-active' : setFixed }"></div>
    <add v-if="showAddbar" ref="add" v-bind="{post, focusInput}" :comment="comment" :replyTo="replyTo" @created="created" @cancel="cancel" :scrollCheck="contribute" :id="`add-${post.id}`" :isGrid="isGrid"></add>
    <transition name="fade">
      <div v-show="showComments" class="comments" ref="allComments"  :class="{hasModal: previewVisible, readOnly: !canCreateComment && fetchCount > 0, 'isEng' : $isStories}">
        <infinite-scroll :callback="fetch" :distance="infiniteScrollDistance" :disable="!isVisible">
          <show v-for="comment in comments" :key="comment.id" :id="`comment-${comment.id}`" :comment="comment" :post="post" :isGrid="isGrid" @reply="formatReply" :selectedID="selectedID" @repliesFetched="repliesFetched" :selectedCommentID="selectedCommentID" @scrollToCommentBox="scrollToCommentBox"></show>
        </infinite-scroll>
        <div v-if="loading"><span class="loader"></span></div>
      </div>
    </transition>
    <div class="is-flex view-all-container">
      <div v-if="!gridModalOpen && post.metadata.comments > 2  && !$isStories" @click="viewAllReplies(post)" class="view-replies">{{$t('projectPage.viewAllReplies')}}</div>
    </div>
  </div>
</template>

<script>
import pluralize from 'pluralize'

import InfiniteScroll from '@/components/Controls/InfiniteScroll'

import Add from './Add'
import Show from './View'
import ShareMenu from '../../ShareDropdown'

import userAgent from '@/libs/user-agent'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import visibility from '@/mixins/visibility'
import DropDown from '@/components/Controls/MetaCountsDropdown'
import dropDownMixin from '@/components/Controls/MetaCountsDropdown/mixin'
import state from '../../state'
import i18n from '@/i18n'

export default {
  components: {
    InfiniteScroll,
    Add,
    Show,
    ShareMenu,
    DropDown
  },
  mixins: [auth, componentState, visibility, dropDownMixin],
  props: ['post', 'edit', 'isGrid', 'gridRef', 'isFeed', 'selectedCommentID'],
  data: function () {
    return {
      fetchCount: 0,
      fetched: 0,
      total: 0,
      loading: false,
      contribute: true,
      hasMore: true,
      replyTo: {
        contribution: null,
        saveParentID: false
      },
      focusInput: false,
      scrollTimer: null,
      seenScrolledComment: false,
      expanded: true,
      setFixed: false,
      loadAll: false,
      reply: false,
      limit: 10,
      visibilityConfig: { toggle: true, options: { rootMargin: '-120px 0px 100px 0px' } },
      dropdowns: {
        likes: dropDownMixin.initDropdown()
      },
      openReply: false,
      replyToCommentID: 0
    }
  },
  mounted: function () {
    if (this.$route.query.reply && this.$route.query.commentID) {
      this.openReply = true
      this.replyToCommentID = this.$route.query.commentID
    }
    if (this.selectedCommentID) {
    }
  },
  watch: {
    contribute: function () {
      this.clearReply()
    },
    scrollToCommentID: function (id) {
      if (id) {
        this.scrollToComment(false)
      }
    },
    expandedAll: function (value) {
      this.expanded = value
      if (this.expanded && this.fetchCount === 0) {
        this.fetch()
      }
    },
    hasLiked: function () {
      this.resetDropdownUsers('likes')
    },
    postID: function () {
      this.resetVars()
      this.fetch()
    }
  },
  destroyed: function () {
    this.detachScrollListener()
  },
  computed: {
    isAuditoriumStory: function () {
      return this.$route.fullPath.includes('/auditoriumStory')
    },
    isTouch: function () {
      return userAgent.isIOS() || userAgent.isAndroid()
    },
    iosMobile: function () {
      return userAgent.isIOS()
    },
    showAddbar: function () {
      return this.canCreateComment && this.contribute && !this.edit && ((this.expanded) || this.$isProjects)
    },
    likesLabel: function () {
      return pluralize('Likes', this.post.metadata.likes)
    },
    buttonTemplate: function () {
      return this.isStory ? 'button is-small is-rounded is-outlined' : ''
    },
    hasLiked: function () {
      return this.isLoggedIn ? this.$store.getters.likedPost(this.post.id, this.currentUser.userName) : false
    },
    isPrivate: function () {
      return this.project ? this.project.isPrivate : false
    },
    upClass: function () {
      return this.expanded ? 'fal fa-chevron-down' : 'fal fa-chevron-up'
    },
    project: function () {
      return this._get(state.project.id) ? this.$store.getters.project(this._get(state.project.id)) || {} : {}
    },
    comments: function () {
      if (this.displayAllComments || this.$isStories) {
        return this.fetchCount > 0 ? this.$store.getters.postComments(this.post.id) : []
      } else {
        return this.fetchCount > 0 ? this.$store.getters.postComments(this.post.id)?.slice(0, 2) : []
      }
    },
    hasComments: function () {
      return this.post && this.post.metadata && this.post.metadata.comments > 0
    },
    selectedID: function () {
      return this.replyTo.contribution ? this.replyTo.contribution.id : 0
    },
    comment: function () {
      return this.replyTo.saveParentID ? this.replyTo.contribution : null
    },
    previewVisible: function () {
      return this._get('carouselPreview', false)
    },
    scrollToCommentID: function () {
      return this._get(state.comments.scrollTo(this.post.id))
    },
    canCreateComment: function () {
      return this._get(state.comments.permissions.create, false)
    },
    expandedAll: function () {
      return this._get(state.posts.repliesExpanded)
    },
    repliesLabel: function () {
      return i18n.t('projectPage.replies')
    },
    showComments: function () {
      return this.isGrid || this.expanded
    },
    isStory: function () {
      return this.$route.name === 'viewStory' || this.$route.name === 'storyFeed'
    },
    showButtons: function () {
      return this.expanded || this.isGrid
    },
    fromStartButtonTemplate: function () {
      return !!this.$route.params.startButton || this.fromTemplate
    },
    displayAllComments: function () {
      return this.gridModalOpen
    },
    gridModalOpen: function () {
      return this._get(state.grid.modalVisible)
    },
    infiniteScrollDistance: function () {
      return this.$route.name === 'viewAuditoriumStory' ? '25' : '50'
    },
    postID: function () {
      return this.post.id
    }
  },
  methods: {
    fetchLikes: function (type, method) {
      const params = { id: this.post.id, limit: 10, offset: this.dropdowns[type].offset }
      return this.fetchDropdown(type, method, params)
    },
    fetchLikedBy: function () {
      return this.fetchLikes('likes', 'postLikedBy')
    },
    openAndReply: function () {
      this.scrollToNewest()
      this.replyToComment(this.post, false)
    },
    like: function () {
      this.$emit('like')
    },
    fetch: function () {
      if (!this.post.id || this.loading || !this.showComments || !this.hasMore || (!this.isVisible && !this.scrollToCommentID)) {
        return
      }

      this.loading = true
      let limit = 0
      if (this.loadAll) {
        limit = this.total
      } else {
        limit = this.limit
      }

      const params = { id: this.post.id, limit, offset: this.fetched }
      this.$store.dispatch('getPostComments', params).then((response) => {
        this.fetchCount++
        this.fetched += response.comments.length
        this.loading = false
        this.total = response.total
        if (this.$isStories) {
          // Posts API requests are cached and could have incorrect counts.
          // Overwrite this value with the known correct count.
          this.$store.dispatch('setPostCommentCount', { id: this.post.id, count: response.total })
        }
        this.hasMore = response.hasMore

        this.$nextTick(() => {
          if (this.loadAll) {
            if (this.reply) {
              this.replyToComment(null, false)
            } else {
              this.scrollToNewest()
            }
          }

          if (this.scrollToCommentID && !this.seenScrolledComment) {
            this.scrollToComment(false)
          }
        })
      }, (error) => {
        this.error = error.message
        this.loading = false
      })
    },
    resetVars: function () {
      this.hasMore = true
      this.isVisible = true
      this.fetched = 0
    },
    created: function () {
      this.$emit('created')
      this.scrollToBottom()
      this.expanded = true
      const addBox = document.getElementById(`add-${this.post.id}`)
      this.$nextTick(() => {
        addBox.scrollIntoView({ block: 'center' })
      })
    },
    replyToComment: function (parent, saveParentID) {
      if (this.hasMore) {
        this.loadAll = true
        this.reply = true
        this.fetch()
      } else {
        this.reply = false
        this.loadAll = false
        this.$nextTick(() => {
          this.$refs.add.$refs.createBox.focus()
          // waiting until the createBox is on the DOM before scrolling
          this.$nextTick(() => {
            if (userAgent.isIE11() || userAgent.isEdge()) {
              this.$refs.add.$el.scrollIntoView(false)
            } else {
              this.$refs.add.$el.scrollIntoView({ block: 'end', behavior: 'auto' })
            }
          })
        })
      }
      // wait a tick since reply will trigger our "contribute" watch which nulls out replyTo
      if (parent) {
        this.$nextTick(() => {
          this.replyTo.contribution = parent
          this.replyTo.saveParentID = saveParentID
        })
      } else {
        this.$nextTick(() => {
          this.$refs.add.$refs.createBox.addAtReply(this.replyTo.contribution)
        })
      }
    },
    scrollToBottom: function () {
      if (this.$refs.allComments) {
        this.$refs.allComments.scrollTop = this.$refs.allComments.scrollHeight - this.$refs.allComments.clientHeight
      }
    },
    repliesFetched: function () {
      if (this.fetchCount === 1) {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
    },
    scrollToComment: function (jump) {
      if (this.scrollTimer) {
        return
      }
      this.expanded = true
      const commentID = this.scrollToCommentID
      if (this.$store.state.comment.comments[commentID]) {
        if (this.openReply) {
          this.replyToComment(this.$store.state.comment.comments[this.replyToCommentID], false)
        }
        this.scrollTimer = setTimeout(() => {
          this.scrollTimer = null
          const comment = document.getElementById(`comment-${commentID}`)
          if (comment) {
            if (userAgent.isIE11() || userAgent.isEdge()) {
              // ie doesnt support anything other than top/bottom (true false)
              comment.scrollIntoView(false)
            } else {
              comment.scrollIntoView({ block: jump ? 'center' : 'start', behavior: jump ? 'auto' : 'smooth' })
            }
            this.seenScrolledComment = true
            this._delete(state.comments.scrollTo(this.post.id))
          } else {
            this.scrollToComment()
          }
        }, 100)
      } else {
        this.fetch()
      }
    },
    clearReply: function () {
      this.replyTo.contribution = null
      this.replyTo.saveParentID = false
    },
    scrollToNewest: function () {
      if (this.hasMore) {
        this.loadAll = true
        this.fetch()
      } else {
        if (this.comments.length) {
          this._set(state.comments.scrollTo(this.post.id), parseInt(this.comments[0].id))
        }
        this.scrollToComment(true)
        this.loadAll = false
      }
    },
    checkFixedHeader: function () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      if (this.$refs.commentsContainer) {
        const bounds = this.$refs.commentsContainer.getBoundingClientRect()
        if (this.$route.name !== 'storyFeed') {
          this.setFixed = this.expanded && (scrollTop >= bounds.top + scrollTop - 52) // 52 => navbar
        }
      }
    },
    toggleRepliesOnClick: function () {
      this.expanded = !this.expanded

      if (this.expanded && this.fetchCount === 0) {
        this.fetch()
      }

      if (!this.expanded && this.setFixed) {
        const comment = document.getElementById(`header-${this.post.id}`)
        this.$nextTick(() => {
          comment.scrollIntoView({ block: 'center' })
        })
      }
    },
    onVisible: function () {
      this.$emit('commentsVisible', true)
      if (this.fetchCount === 0) {
        this.fetch()
      }
      this.attachScrollListener()
    },
    onNotVisible: function () {
      this.$emit('commentsVisible', false)
      this.detachScrollListener()
      this.setFixed = false
    },
    attachScrollListener: function () {
      if (this.isGrid && this.gridRef) {
        this.gridRef.addEventListener('scroll', this.checkFixedHeader)
      } else {
        window.addEventListener('scroll', this.checkFixedHeader)
      }
    },
    detachScrollListener: function () {
      if (this.isGrid && this.gridRef) {
        this.gridRef.removeEventListener('scroll', this.checkFixedHeader)
      } else {
        window.removeEventListener('scroll', this.checkFixedHeader)
      }
    },
    formatReply: function (replyObject) {
      this.replyToComment(replyObject.contribution, replyObject.saveParentID)
    },
    cancel: function () {
      this.clearReply()
      this.$emit('cancel')
    },
    viewAllReplies: function (post) {
      this.$emit('showPostGrid', post.id)
    },
    scrollToCommentBox: function () {
      this.$refs.allComments.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.6s;
}

.fade-leave-active {
  transition:  opacity 0.1s;
  opacity: 0;
}
  .comments {
    background-color: #f2f2f2;
    padding-top: 0.5rem;
    &.hasModal {
      overflow-y: visible; /* safari modal issue fix */
    }
    &.readOnly {
      border-top: solid 2px #f2f2f2;
    }
   .border-bottom:last-child{
    border-bottom: none;
   }
  }

  .load {
    text-align: center;
    padding: 0.5rem 0;
    position: relative;
    border-top: 1px solid whitesmoke;

    .count{
      position: absolute;
      right: 1rem;
      font-style: italic;
      color: #b5b5b5;
      font-size: 0.75rem;
      line-height: 1.5rem;
    }
  }
  .loader {
    display: block;
    font-size: 2rem;
    margin: 1rem auto;
  }

  .progress {
    height: 1px;
    border-radius: 0;
    padding: 0 10px;
    margin-bottom: 0;
  }

  .reply-to {
    background: whitesmoke;
    border-radius: 100px;
    height: 2rem;
  }
  .header-placeholder {
    height: 40px;
    display: none;
  }
  .placeholder-active {
    display: block
  }

  .comments-header {
    background-color: #fbfbfb;
    border: 1px solid $grey-lighter;
    @include mobile {
      width: 100vw;
    }
    &.fixed-position {
      position: fixed;
      z-index: 10;
      top: $nav-height-px;
      width: 800px;
      max-width: 800px;
      @media (max-width: 800px) {
        width: 100vw;
      }
      &.stories-comment-header {
        width: 700px;
        max-width: 700px;
        border-bottom: solid 1px #f2f2f2;
      }
    }
    height: 40px;
    align-items: center;
    justify-content: space-between;
    .replies-title {
      padding-left: 1rem;
      @include mini-mobile {
        font-size: 0.85rem;
      }
      .fa-minus-square, .fa-plus-square {
        font-size: 1rem;
      }
      .loader-container {
        padding-left: 0.25rem;
        display: inline-block;
        .loader {
          margin: 0;
          font-size: 1rem;
        }
      }
    }
    .buttons {
      margin-right: 0.5rem;
      &.grid-modal {
        margin-right: 1.5rem;
      }
      .button {
        padding: 0.25rem 0.5rem;
      }
    }

    &.stories-comment-header {
      height: auto;
      background: #fff;
      border: none;
    }
  }
  .is-grid {
    .comments-header {
      &.fixed-position {
        &.ios {
          top: calc(5% + 9px);  // based on .modal-content ios-fix
        }
        @include mobile {
          top: calc(12.5vh + 19px); // based on .modal-content max-height + half of close modal height
        }
        @include tablet {
          top: 120px;
          width: 90%;
          max-width: 90%;
        }
        @include desktop {
          top: 20px;
          width: 60vw;
          max-width: 60vw;
        }
        @include fullhd {
          max-width: 900px;
        }
      }
    }
  }

  .space-between {
    justify-content: space-between;
  }

  .story-padding {
    margin: 0;
    margin-top: 2rem;
    border-top: 1px solid lightgrey;
    padding: 1rem 0rem 3rem 0rem;
    width: 100%;
    @include mobile {
      padding: 1rem 0.1rem;
    }
  }

  .icon-label{
    margin-left:0.3rem;
    font-size: 0.7rem;
  }

  .hidden-header {
    justify-content: center;
    background-color: #fbfbfb;
    & > div {
      margin-left: 1rem;
    }
  }

  .arrow-padding {
    padding: 0 0.3rem;
  }

  .comments-container {
    padding-top: 1.25rem;
    position: relative;
    background-color: #f2f2f2;
    &.no-comments {
      border-top: 10px solid #f2f2f2;
    }
    &.is-expanded {
      padding-bottom: 1rem;
    }
    &.is-start-page {
      padding-bottom: 0;
    }
    &-auditoriumYSC {
     padding-right: .5rem;
     padding-left: .5rem
    }
  }

  .comments-container.isEng{
    padding: 0rem 3.7rem;
    @include mobile {
      padding: 0;
    }
  }

  .is-grid {
    &.comments-container {
      width: 100%;
    }

    .comments {
      padding: 0.5rem;
      width: 100%;
    }
    .create-comment {
      margin-left: 2.9rem;
      margin-right: 0.6rem;
      margin-bottom: 0.5rem;
      &.unfocus {
        padding: 0 0.5rem 1rem 0.5rem;
      }
      @include mobile {
        margin-left: 2.1rem;
        margin-right: 0.9rem;
      }
    }
  }

  .thumb .fa-thumbs-up.far {
    color: $primary;
  }

  .thumb {
    .dropper {
      position: relative;
      margin-left: 0;
      .show-dropdown{
        left: -0.8rem;
        bottom: 0.9rem;
      }
    }
  }

  .right-buttons {
    .share-button {
      margin-left: 0.5rem;
      @include mobile{
        margin-right: 0.25rem;
      }
    }
  }
  .isEng{
    background-color: #F8F8F8;
  }

  .view-all-container {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div {
      border: 1px solid black;
      text-transform: uppercase;
      padding: 0.25rem 0.75rem;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        color: $primary;
        border: 1px solid $primary;
        transition: all 0.1s;
      }
    }
  }
</style>
